var map = {
	"./add-circle.svg": "uczA",
	"./add.svg": "Xlgx",
	"./appointment.svg": "xqNF",
	"./backspace.svg": "ppPx",
	"./bicycle.svg": "V3pC",
	"./car.svg": "AJtd",
	"./charge.svg": "AjE+",
	"./cold_down.svg": "qo2m",
	"./coupons.svg": "Jt+f",
	"./order.svg": "yFCU",
	"./right.svg": "2RDt",
	"./wallet.svg": "rJkQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c+w5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg ^\.\/.*\.svg$
// module id = c+w5
// module chunks = 44